import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";

import {useEffect, useRef, useState } from 'react';
import postRelatorio from '../../service/postRelatorio';
import React from 'react';
import { Toolbar } from 'primereact/toolbar';
import { Calendar } from 'primereact/calendar';
import { Nullable } from "primereact/ts-helpers";
import { FiltrarRelatorio } from '../../interface/FiltrarRelatorio';
import { Messages } from 'primereact/messages';
import { Button } from 'primereact/button';
import { RadioButton } from 'primereact/radiobutton';
import { MultiSelect } from 'primereact/multiselect';
import { carregarFranquias } from '../../hooks/useFranquias';




export default function FiltrarApuracaoBilhetePage() {
  const { t } = useTranslation();
  const [data, setData] = useState<Nullable<Date>>(null);
  const [origem, setOrigem] = useState<String>('FRANQUEADO');
  const [dataFinal, setDataFinal] = useState<Nullable<Date>>(null);
  const msgs = useRef<Messages>(null);
  const [selectedFranquias, setSelectedFranquias] = useState([]);
  const [franquias, setFranquias] = useState<any>([]);
  const padTo2Digits = (num: number) => {
    return num.toString().padStart(2, '0');
  }
  const formatDate = (date:Nullable<Date>) => {
    if(date){
      return [
        padTo2Digits(date.getDate()),
        padTo2Digits(date.getMonth() + 1),
        date.getFullYear(),
      ].join('/');
    }
   
  }
  
  const salvarRelatorio = () => {
    if(data && dataFinal && dataFinal >= data && selectedFranquias && Array.isArray(selectedFranquias) && selectedFranquias.length > 0){
      const franquiasId : string[] = []
      selectedFranquias.forEach((franq:any) => franquiasId.push(franq.id))
      const filtrarRelatorio:FiltrarRelatorio ={tipoRelatorio:'APURACAO_BILHETE', tipoArquivo: 'CSV', filtro:{ data:formatDate(data), dataFinal: formatDate(dataFinal), origem: origem, franquias:franquiasId }};
      postRelatorio(filtrarRelatorio).then((data) => {
        if (msgs.current) {
          msgs.current?.clear();
          msgs.current?.show([
              { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
             
          ]);
        }
      });
    }
    else{
      msgs.current?.clear();
      msgs.current?.show([
          { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Data Inicial e Data Final Devem ser preenchidas com data Final Superior ou igual Data Inicial e Selecione uma franquia', closable: false }
         
      ]);
    }
  }
  
  const endContent = (
    <React.Fragment>
      <div  style={{background:'transparent'}}>
        <div className='grid'>
          <div className="col-consulta align-items-center justify-content-end gap-2">
       
            <div className="flex-auto" style={{width:'21rem'}}>
              <label htmlFor="data" className="font-bold block mb-2">{t('dataInicial')} </label>
              <Calendar id='data' value={data} onChange={(e) => setData(e.value)} showIcon dateFormat="dd/mm/yy" locale='pt'/>
            </div>
          </div>
        </div>
        <div className='grid'>
          <div className='col'>
            <div className="grid">
              <div className="col p-fluid flex flex-wrap">
                <div className="flex-consulta justify-content-center">
                  <div className="flex-consulta flex-column gap-3">
                    <div className="flex-consulta align-items-center">
                      <RadioButton inputId="franqueado" name="usuario" value="FRANQUEADO" onChange={(e) => setOrigem(e.value)} checked={origem === 'FRANQUEADO'} />
                      <label htmlFor="agrupadoPorUsuario" className="ml-2">Franqueado</label>
                    </div>
                    <div className="flex-consulta align-items-center">
                      <RadioButton inputId="master" name="cliente" value="MASTER" onChange={(e) => setOrigem(e.value)} checked={origem === 'MASTER'} />
                      <label htmlFor="master" className="ml-2">Master</label>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
          
      </div>
      </div>
      <div  style={{background:'transparent', marginLeft:'10rem'}}>
        <div className='grid'>
          <div className='col'>
            <div className="flex-auto" style={{width:'21rem'}}>
              <label htmlFor="dataFinal" className="font-bold block mb-2">{t('dataFinal')} </label>
              <Calendar id='dataFinal' value={dataFinal} onChange={(e) => setDataFinal(e.value)} showIcon dateFormat="dd/mm/yy" locale='pt'/>
            </div>
          </div>
        </div>
        <div className='grid'>
          <div className='col'>
            <div className="flex-auto" style={{width:'21rem'}}>
              <label htmlFor="franquia" className="font-bold block mb-2">{t('franquia')} </label>
              <MultiSelect value={selectedFranquias} onChange={(e) => setSelectedFranquias(e.value)} options={franquias} optionLabel="nome" display="chip" 
                placeholder="Selecione Franquias" filter className="w-full md:w-20rem" />
            </div>
          </div>
        </div>
      </div>
      <Button style={{marginLeft:"2rem", backgroundColor:'#183462'}} label="Gerar" onClick={() => {salvarRelatorio()}}   />
    </React.Fragment>
);


useEffect(()=>{
  carregarFranquias().then(lista => {
    setFranquias(lista);
  })
},[])

  return (
    <Container>
      <div className="row">
          <div className="col-lg-12 mb-3">
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
              <h1 className="h3 mb-0 text-gray"><i className="pi pi-filter" style={{ fontSize: '2.0rem' }}></i> {t('relatorioApuracaoBilhete')}</h1>
            </div>     
          </div>
      </div>
      <Messages ref={msgs} />
      <div className="card">
        <Toolbar start={endContent} />
      </div>
                
    </Container>
  )
}
